import React from "react"
import { ContainerFull } from "../components/GeneralComponents"
import styled from "styled-components"

const H1 = styled.h1`
  font-size: 2.4rem;
  color: ${(props) => props.theme.primary};
  margin-bottom: 1em;
`
const H2 = styled.h2`
  font-size: 1.5rem;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
`

export function Terms(): JSX.Element {
    return (
        <ContainerFull
            style={{
                fontFamily: '"Rubik", sans-serif',
                maxWidth: 800,
                margin: "0 auto",
                fontSize: "1.25rem",
                lineHeight: 1.7,
            }}
        >
            <H1>Terms of Service</H1>
            <p>
                These Terms of Service ("Terms") constitute a legally binding agreement between you ("Customer,"
                "you," or "your") and Pananosis Laboratories LLC, a Massachusetts limited liability company offering the PLab Sequencing service ("PLab Sequencing," "PLab," "we," "us," or "our"), governing your access to and use of
                our genomic sequencing and related services ("Services").
            </p>
            <p>
                By placing an order, creating an account, or using any of our Services, you acknowledge that you
                have read, understood, and agreed to be bound by these Terms. If you do not agree to these
                Terms, do not use our Services.
            </p>

            <H2>1. Orders and Services</H2>
            <ul>
                <li>1.1. All orders submitted to PLab are subject to acceptance and availability. We reserve the right to accept or reject any order in our sole discretion.</li>
                <li>1.2. You agree to provide complete and accurate order details. PLab is not responsible for delays or losses from inaccurate information.</li>
                <li>1.3. Estimated turnaround times are non-binding.</li>
            </ul>

            <H2>2. Payment</H2>
            <ul>
                <li>2.1. Payment is due in full before release of results, unless otherwise agreed in writing.</li>
                <li>2.2. Accepted payment methods are listed on the website.</li>
                <li>2.3. Invoices are due per specified terms. Late payments may incur fees.</li>
            </ul>

            <H2>3. Results and Data</H2>
            <ul>
                <li>3.1. Results will be delivered via email or user account.</li>
                <li>3.2. PLab is not responsible for data loss due to user error or third-party issues.</li>
                <li>3.3. Results are for research use only unless otherwise stated.</li>
            </ul>

            <H2>4. Cancellations and Changes</H2>
            <ul>
                <li>4.1. All orders are final and cannot be canceled by the user.</li>
                <li>4.2. If you must request a cancelation or change, contact us at <a href="mailto:support@plabsequencing.com">support@plabsequencing.com</a>. Such requests are at our sole discretion.</li>
            </ul>

            <H2>5. Confidentiality and Ownership</H2>
            <ul>
                <li>5.1. Both parties agree to maintain the confidentiality of all non-public information.</li>
                <li>5.2. Biological samples and raw data remain Customer property. PLab may use anonymized data internally.</li>
                <li>5.3. PLab retains all rights to its technologies and methods.</li>
            </ul>

            <H2>6. Privacy</H2>
            <ul>
                <li>6.1. Personal information is handled per our Privacy Policy.</li>
                <li>6.2. We do not share your data except as required by law or to fulfill your order.</li>
            </ul>

            <H2>7. Liability</H2>
            <ul>
                <li>7.1. PLab is not liable for indirect, incidental, or consequential damages.</li>
                <li>7.2. Total liability is limited to the amount paid for the relevant order.</li>
            </ul>

            <H2>8. Changes to Terms</H2>
            <ul>
                <li>8.1. We may modify these Terms at any time.</li>
                <li>8.2. Continued use of the Services indicates acceptance of updated Terms.</li>
            </ul>

            <H2>9. Contact</H2>
            <p>
                Pananosis Laboratories LLC<br />
                Email: <a href="mailto:legal@plabsequencing.com">legal@plabsequencing.com</a><br />
                Website: <a href="https://www.plabsequencing.com">www.plabsequencing.com</a>
            </p>

            <p style={{ color: "#888", marginTop: 32, fontSize: "1.1rem" }}>
                {/* Last Updated: {new Date().toLocaleDateString()} */}
                Last Updated: 06/10/2025
            </p>
        </ContainerFull>
    )
}
